<template>
  <div v-if="visible" :class="['custom-alert', type]" @click="close">
    <i :class="iconClass" class="alert-icon"></i>
    <span>{{ message }}</span>
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps, computed } from 'vue';

const props = defineProps({
  message: {
    type: String,
    required: true
  },
  type: {
    type: String,
    default: 'info' // 'success' | 'error' | 'warning' | 'info'
  },
  duration: {
    type: Number,
    default: 3000
  }
});

const visible = ref(true);

const close = () => {
  visible.value = false;
};

const iconClass = computed(() => {
  switch (props.type) {
    case 'success':
      return 'fas fa-check-circle';
    case 'error':
      return 'fas fa-exclamation-circle';
    case 'warning':
      return 'fas fa-exclamation-triangle';
    case 'info':
    default:
      return 'fas fa-info-circle';
  }
});

onMounted(() => {
  setTimeout(() => {
    close();
  }, props.duration);
});
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css');

.custom-alert {
  position: fixed;
  top: 24px;
  right: 24px;
  padding: 16px 24px;
  border-radius: 16px;
  color: #f1f5f9;
  cursor: pointer;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  min-width: 280px;
  transition: all 0.3s ease;
  font-family: 'Inter', system-ui, sans-serif;
  font-size: 15px;
  font-weight: 500;
}

.custom-alert:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.45);
}

/* 不同类型颜色（与登录页深色科技风统一） */
.custom-alert.success {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  border-color: rgba(163, 230, 187, 0.3);
}

.custom-alert.error {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  border-color: rgba(248, 180, 180, 0.3);
}

.custom-alert.warning {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  border-color: rgba(253, 224, 171, 0.3);
}

.custom-alert.info {
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  border-color: rgba(147, 197, 253, 0.3);
}

.alert-icon {
  font-size: 20px;
  flex-shrink: 0;
}

/* 手机端适配 */
@media (max-width: 480px) {
  .custom-alert {
    left: 16px;
    right: 16px;
    min-width: auto;
    border-radius: 14px;
    padding: 14px 20px;
  }
}
</style>